import styled from 'styled-components';
import CompanySectorSelect from './CompanySectorSelect';

const CompanySectorSelectStyled = styled(CompanySectorSelect)`
  ${props => props.theme.input.select};
`;

export default CompanySectorSelectStyled;
